import { usePricingConfig } from "../../../pricing-config/hooks";
import {
  BaseConfigCard,
  RulesCard,
  HistoryCard,
} from "../../../pricing-config/components";

export function Pricing({ user }: { user: any }) {
  const userId = user?.id;
  const { data, isLoading, isError } = usePricingConfig(userId);

  if (!userId) return null;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center py-16">
        <p className="text-sm text-content-tertiary">
          Failed to load pricing config
        </p>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="flex flex-col gap-4 overflow-auto h-full p-1">
      <BaseConfigCard config={data.config} userId={userId} />
      <RulesCard rules={data.rules} userId={userId} />
      <HistoryCard history={data.changeHistory} userId={userId} />
    </div>
  );
}
